import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DespachosSidebar from "./components/DespachosSidebar";
import DespachosHeader from "./components/DespachosHeader";

const DespachosLayout = () => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
        setIsSidebarOpen(false);
    }, [location.pathname]);

    return (
        <div className="relative flex h-full w-full overflow-hidden bg-gray-50">
            <DespachosSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
            {isSidebarOpen && (
                <button
                    type="button"
                    aria-label="Cerrar menu de despachos"
                    className="fixed inset-0 z-30 bg-black/30 backdrop-blur-sm lg:hidden"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                <DespachosHeader onOpenSidebar={() => setIsSidebarOpen(true)} />
                <main className="flex-1 overflow-auto p-3 sm:px-6 sm:py-3">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DespachosLayout;
